<template>
  <div class="course-mooc">
    <div class="mooc-title">{{ menu.module_name }}</div>
    <div class="type-list">
      <div class="type-item" :class="{ active: typeId == '' }" @click="searchCourseList('')">
        全部
      </div>
      <div
        class="type-item"
        :class="{ active: item.id == typeId }"
        v-for="item in typeList"
        @click="searchCourseList(item.id)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="module-content">
      <div class="course-card-list">
        <template v-if="homeCourseList && homeCourseList.length > 0">
          <CourseCard
            :course-data="course"
            v-for="(course, index) in homeCourseList"
            :key="course.id"
            :show-label="true"
            :userInfo="userInfo"
            :authType="authType"
            :style="{ '--delay': `${index * 0.1}s` }"
            class="animated-card"
          />
        </template>
        <div v-else class="no-data">
          <Empty />
        </div>
      </div>
      <div class="right-content">
        <div class="content-title">海量课程</div>
        <div class="content-desc">
          <div class="desc-item">·专属教学宝库</div>
          <div class="desc-item">·前沿理念汇聚</div>
          <div class="desc-item">·创新案例云集</div>
        </div>
        <div class="right-btn" @click="handleMore">
          <span>查看更多</span>
          <div class="icon">
            <img
              src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/494869a003dc4f3a94b72ff970738cd8.png"
            />
          </div>
        </div>
        <img
          class="right-img"
          src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202509/7b02b744284943b1846324e0533409b3.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CourseCard from './CourseCard.vue'
import CardHeader from '@/pages/components/CardHeader'
import Live from './Live.vue'
import { Empty } from 'zhs-components'
import UserCard from './UserCard/index'

export default {
  components: {
    CourseCard,
    Live,
    Empty,
    CardHeader,
    UserCard
  },
  props: {
    courseType: Number,
    menu: Object,
    userInfo: {
      type: Object,
      default: null
    },
    zhsRole: {
      type: Number || String,
      default: 0
    },
    isTop: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.getAuth()
    this.getTypeList()
  },
  watch: {
    typeId: {
      handler(val) {
        this.getHomeCourseList()
      },
      immediate: true
    }
  },
  data() {
    return {
      homeCourseList: [],
      courseCategorys: [],
      classId: undefined,
      authType: 0,
      typeList: [],
      hiddenMoreClass: true,
      typeId: ''
    }
  },
  methods: {
    handleMore() {
      window.open(
        `/courseList.html?type=1&name=${this.menu.module_name}&menuId=${this.menu.menu_id}`
      )
    },
    async getHomeCourseList() {
      const homeCourse = await this.$http.getHomeMooc({
        num: this.menu.num,
        menu_id: this.menu.menu_id,
        classify_id: this.typeId
      })
      console.log(homeCourse, 'ioioipipoipoiopi参数')
      this.homeCourseList = homeCourse
    },
    async getAuth() {
      const res2 = await this.$http.getConfigList()
      this.authType = res2.find(item => item.code == '10401')
        ? res2.find(item => item.code == '10401').auth_type
        : 0
    },
    async getTypeList() {
      const res = await this.$http.getCourseType({
        menu_id: this.menu.menu_id
      })
      this.typeList = res
      // if (res && res.length) {
      //   this.typeId = res[0].id
      // }
    },
    searchCourseList(id) {
      this.typeId = id
    }
  }
}
</script>

<style lang="scss" scoped>
.animate-wrap {
  .animated-card {
    opacity: 0;
    transform: translateX(-20px);
    height: 235px;
  }
  &.visible {
    .animated-card {
      animation: slideIn 0.5s forwards;
      animation-delay: var(--delay, 0.7s);
    }
  }
  @keyframes slideIn {
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
}
.course-mooc {
  padding: 40px 80px 0;
  box-sizing: border-box;
  height: 686px;
  box-sizing: border-box;
  .mooc-title {
    color: #1c212a;
    font-family: 'Alibaba PuHuiTi';
    font-size: 32px;
    font-weight: 700;
    height: 48px;
    line-height: 48px;
    &::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 24px;
      background-color: #194189;
      margin-right: 8px;
    }
  }
  .type-list {
    display: flex;
    margin-top: 20px;
    .type-item {
      width: 112px;
      height: 40px;
      background-color: #f7f8fa;
      color: #1d2129;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      line-height: 40px;
      margin-right: 28px;
      border-radius: 6px;
      cursor: pointer;
      &:hover {
        color: #194189;
      }
      &.active {
        background-color: #194189;
        color: #fff;
      }
    }
  }
  .module-content {
    margin-top: 32px;
    display: flex;
    justify-content: center;
    .course-card-list {
      width: 646px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 16px 24px;
    }
    .no-data {
      width: 646px;
    }
    .right-content {
      width: 610px;
      height: 486px;
      background-color: #e8f5fe;
      border-radius: 16px;
      margin-left: 24px;
      position: relative;
      padding-top: 64px;
      padding-left: 48px;
      .content-title {
        color: #1c212a;
        font-family: 'Alibaba PuHuiTi 2.0';
        font-size: 36px;
        font-style: normal;
        font-weight: 900;
        letter-spacing: 2px;
      }
      .content-desc {
        margin-top: 30px;
        .desc-item {
          color: #84909d;
          font-family: 'PingFang SC';
          font-size: 20px;
          font-style: normal;
          font-weight: 400;
          margin-top: 20px;
        }
      }
      .right-btn {
        width: 176px;
        height: 50px;
        background-color: #194189;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 62px;
        cursor: pointer;
        .icon {
          width: 40px;
          height: 40px;
          margin-left: 8px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        &:hover {
          .icon {
            img {
              animation: btnFadeIn 0.3s ease-in-out;
            }
          }
        }
        span {
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          color: #fff;
        }
        @keyframes btnFadeIn {
          0% {
            opacity: 0;
            width: 0;
            height: 100%;
          }
          100% {
            opacity: 1;
            width: 100%;
            height: 100%;
          }
        }
      }
      .right-img {
        height: 478px;
        position: absolute;
        right: -10px;
        top: 8px;
        object-fit: cover;
      }
    }
  }
}
</style>
